module.exports = __webpack_public_path__ + "img/login-logo2.5a68b432.png";